module.exports = __webpack_public_path__ + "static/media/8.0d09f6f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/07/projects/01/8.jpg
// module id = 425
// module chunks = 0